import { render, staticRenderFns } from "./Bonsv3.vue?vue&type=template&id=4e3c158a&"
import script from "./Bonsv3.vue?vue&type=script&lang=js&"
export * from "./Bonsv3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports